var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6408 22.1238L14.5146 18.8381L15.8544 17.5238L17.6408 19.2762L21.6602 15.3333L23 16.8667L17.6408 22.1238ZM12.2816 9.85714H8.93204V17.5238H11.2767C11.3883 16.6476 11.835 15.7714 12.2816 15.0048V9.85714ZM15.6311 9.85714V12.3762C16.301 12.1571 17.0825 12.0476 17.8641 12.0476C18.199 12.0476 18.6456 12.0476 18.9806 12.1571V9.85714H15.6311ZM11.2767 19.7143H0V23H12.8398C12.0583 22.1238 11.5 20.919 11.2767 19.7143ZM21.2136 5.47619L10.6068 0L0 5.47619V7.66667H21.2136V5.47619ZM5.58252 17.5238V9.85714H2.23301V17.5238H5.58252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCheckIcon);
export default __webpack_public_path__ + "static/media/bank-check-icon.c3387d8ebe524c87425ec3577701d551.svg";
export { ForwardRef as ReactComponent };